import styled from "styled-components";

const Result = styled.div`
  position: relative;

  .ant-input {
    margin-top: 8px;
  }
`;

const WrapperForm = styled.div`
  position: relative;
  margin-top: 32px;
`;

export { Result, WrapperForm };
